import { Card } from '@components/primitives/Card.js'
import { Button } from '@components/primitives/Button.js'
import { Input } from '@components/primitives/Input.js'
import { MoneyInput } from '@components/primitives/MoneyInput.js'
import { Alert } from '@components/primitives/Alert.js'
import { RESERVA_CONTINGENCIA_PADRAO_PCT } from '@utils/constants.js'
import type { ConfigPageState } from './useConfigPage.js'

type Props = Pick<
  ConfigPageState,
  | 'valorMinimoNF'
  | 'dataAlvara'
  | 'reservaPct'
  | 'dataPrevisaoTermino'
  | 'savingConf'
  | 'savedConf'
  | 'setValorMinimoNF'
  | 'setDataAlvara'
  | 'setReservaPct'
  | 'setDataPrevisaoTermino'
  | 'handleSaveConfiguracoes'
>

export function AvancadoSection({
  valorMinimoNF,
  dataAlvara,
  reservaPct,
  dataPrevisaoTermino,
  savingConf,
  savedConf,
  setValorMinimoNF,
  setDataAlvara,
  setReservaPct,
  setDataPrevisaoTermino,
  handleSaveConfiguracoes,
}: Props) {
  return (
    <Card surface='raised'>
      <div className='cf3-config-section'>
        <p className='cf3-config-section__title'>Metas e controles</p>

        <p className='cf3-config-section__desc'>
          Previsão de término alimenta o cronograma e o painel. A reserva para imprevistos protege o
          orçamento: o app avisa quando os gastos entram nessa faixa.
        </p>

        {savedConf && <Alert variant='success' title='Configurações salvas!' message='' />}

        <div className='cf3-config-fields'>
          <Input
            name='dataPrevisaoTermino'
            label='Previsão de término da obra'
            type='date'
            value={dataPrevisaoTermino}
            hint='Se vazio, usa o fim da última fase do cronograma.'
            onChange={(e) => setDataPrevisaoTermino(e.target.value)}
          />
          <Input
            name='reservaPct'
            label='Reserva para imprevistos (%)'
            type='number'
            suffix='%'
            value={reservaPct}
            placeholder={String(RESERVA_CONTINGENCIA_PADRAO_PCT)}
            hint={`Recomendado 5 a 10%. Vazio = ${RESERVA_CONTINGENCIA_PADRAO_PCT}%.`}
            onChange={(e) => setReservaPct(e.target.value)}
          />
          <MoneyInput
            label='Valor mínimo para exigir NF'
            value={valorMinimoNF ? Number(valorMinimoNF) : 0}
            placeholder='Ex: 500,00'
            onChange={(v) => setValorMinimoNF(v > 0 ? String(v) : '')}
          />
          <Input
            name='dataAlvara'
            label='Data do Alvará (para CNO)'
            type='date'
            value={dataAlvara}
            onChange={(e) => setDataAlvara(e.target.value)}
          />
        </div>

        <Button size='sm' onClick={handleSaveConfiguracoes} loading={savingConf}>
          Salvar
        </Button>
      </div>
    </Card>
  )
}
